import { useEffect, useRef, useState } from 'react'

import { ValidatedByCountryFields } from 'clickNgo/configs/validation'
import { fetchValidationInfoByCountry } from 'clickNgo/services/validation'
import Logger from 'core/utils/Logger'

export type TEmailPixelsScope = 'loading' | 'in' | 'out'

interface IAnsweredScope {
  countryCode: string
  scope: Exclude<TEmailPixelsScope, 'loading'>
}

const scopeBeforeAnswer = (countryCode: string): TEmailPixelsScope =>
  countryCode ? 'loading' : 'out'

export const useEmailPixelsScope = (countryCode = ''): TEmailPixelsScope => {
  const [answered, setAnswered] = useState<IAnsweredScope | null>(null)
  const latestRequestNumberRef = useRef(0)

  useEffect(() => {
    const requestNumber = ++latestRequestNumberRef.current
    const isLatestRequest = () => requestNumber === latestRequestNumberRef.current

    setAnswered(null)

    if (!countryCode) {
      return
    }

    Promise.resolve()
      .then(() =>
        fetchValidationInfoByCountry({ countryCode, field: ValidatedByCountryFields.EMAIL_PIXELS })
      )
      .then(({ isRequired }) => {
        if (isLatestRequest()) {
          setAnswered({ countryCode, scope: isRequired ? 'in' : 'out' })
        }
      })
      .catch((error: unknown) => {
        Logger.error('useEmailPixelsScope: ', error)
        if (isLatestRequest()) {
          setAnswered({ countryCode, scope: 'out' })
        }
      })
  }, [countryCode])

  return answered !== null && answered.countryCode === countryCode
    ? answered.scope
    : scopeBeforeAnswer(countryCode)
}
